import React from "react";
import { LegalLayout, LegalSection } from "../components/LegalLayout";
import { COMPANY } from "../lib/constants";

const SECTIONS = [
  { id: "roles", label: "1. Two roles" },
  { id: "collect", label: "2. What we collect" },
  { id: "why", label: "3. Why we use it" },
  { id: "where", label: "4. Where it is stored" },
  { id: "share", label: "5. Who we share it with" },
  { id: "retention", label: "6. How long we keep it" },
  { id: "rights", label: "7. Your rights" },
  { id: "cookies", label: "8. Cookies" },
  { id: "children", label: "9. Children" },
  { id: "incidents", label: "10. Security incidents" },
  { id: "changes", label: "11. Changes" },
  { id: "grievance", label: "12. Grievance Officer" },
];

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      sections={SECTIONS}
      seo={{
        title: "Privacy Policy | Priyajit Systems Private Limited",
        description: "How Priyajit Systems Private Limited collects, uses, stores and protects personal data under the Digital Personal Data Protection Act, 2023. All production data is stored in India.",
      }}
    >
      <p className="text-[17px] leading-[1.75] text-slate-700">
        Priyajit Systems Private Limited respects your privacy and follows the Digital Personal Data Protection Act, 2023
        and the Information Technology Act, 2000 with its rules. This policy explains what we collect, why, and your choices.
      </p>

      <LegalSection id="roles" heading="1. Two roles.">
        <p>For website visitors, demo requests and our customers' business accounts, we decide how data is used (Data Fiduciary). For patient data that hospitals enter into Atikxzio HMS, the hospital is the Data Fiduciary and we process it only on its instructions (Data Processor). Patients should contact their hospital first about their records.</p>
      </LegalSection>

      <LegalSection id="collect" heading="2. What we collect.">
        <ul className="list-disc space-y-2 pl-5">
          <li>Contact details you give us: name, phone, email, organisation, message.</li>
          <li>Account data: staff names, mobile numbers, emails, roles, login and device records.</li>
          <li>Billing data: GSTIN, billing address, invoices and payment status. Card, UPI and bank details are handled by the payment gateway, not stored by us.</li>
          <li>Usage data: pages visited, browser, IP address and approximate city, used for security and improving the product.</li>
          <li>Patient data (HMS, as processor): demographics, visits, vitals, bills and clinical notes entered by the hospital. We never store Aadhaar numbers.</li>
        </ul>
      </LegalSection>

      <LegalSection id="why" heading="3. Why we use it.">
        <p>To provide and support the Services, send account messages (invites, password resets, receipts), issue invoices, keep the platform secure, meet legal duties, and, with your consent, send product updates. We do not sell personal data and do not use patient data for advertising or AI training.</p>
      </LegalSection>

      <LegalSection id="where" heading="4. Where it is stored.">
        <p>All production data is stored on servers located in India, encrypted in transit and at rest, with daily backups.</p>
      </LegalSection>

      <LegalSection id="share" heading="5. Who we share it with.">
        <p>Only service providers who help us run the Services, under contract: cloud hosting, email and WhatsApp/SMS delivery, payment gateways (such as Cashfree Payments) and error monitoring. We disclose data to authorities only when the law requires it.</p>
      </LegalSection>

      <LegalSection id="retention" heading="6. How long we keep it.">
        <p>Account and billing records: as long as you are a customer plus the period tax law requires (currently 8 years for invoices). Hospital data: for the subscription, then 90 days for export, then deleted unless the hospital or the law requires otherwise. Website enquiries: 2 years.</p>
      </LegalSection>

      <LegalSection id="rights" heading="7. Your rights.">
        <p>You can ask to access, correct or erase your personal data, withdraw consent, or nominate someone to act for you. Write to the Grievance Officer below; we may need to verify your identity.</p>
      </LegalSection>

      <LegalSection id="cookies" heading="8. Cookies.">
        <p>We use essential cookies for login and security, and basic analytics. You can block cookies in your browser; some features may stop working.</p>
      </LegalSection>

      <LegalSection id="children" heading="9. Children.">
        <p>Our HMS services are for organisations, not children. Atikxzio CMH, when launched, will collect data of anyone under 18 only with verifiable parental consent.</p>
      </LegalSection>

      <LegalSection id="incidents" heading="10. Security incidents.">
        <p>If a breach affects your data, we will inform you and the authorities as the law requires.</p>
      </LegalSection>

      <LegalSection id="changes" heading="11. Changes.">
        <p>We will post updates here with a new date and notify customers of material changes by email.</p>
      </LegalSection>

      <LegalSection id="grievance" heading="12. Grievance Officer.">
        <p>{COMPANY.grievanceName}, Priyajit Systems Private Limited, A-13, Upper Ground Floor, Graphix Tower 2, Sector 62, Noida, Uttar Pradesh 201301. Email: {COMPANY.grievanceEmail}. Phone: {COMPANY.phone}. We acknowledge complaints within 48 hours and resolve them within 30 days.</p>
      </LegalSection>
    </LegalLayout>
  );
}
